"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PsychrometricChart = void 0;
const property_1 = require("@genesys/property");
const React = __importStar(require("react"));
const loader_1 = require("./loader");
class PsychrometricChart extends React.Component {
    constructor(props) {
        super(props);
        this.fetchHasBeenCancelled = false;
        this.body = "";
        this.state = { src: undefined };
    }
    componentDidMount() {
        this.setBody(makeBody(this.props));
    }
    componentWillUnmount() {
        this.cancelFetch();
    }
    componentDidUpdate() {
        const body = makeBody(this.props);
        if (body !== this.body) {
            this.setBody(body);
        }
    }
    // In case it was unmounted before loading completed.
    // It would be better to cancel the fetch in `componentWillUnmount`,
    // but fetch cancellation doesn't work in ie11. 😕
    cancelFetch() {
        this.fetchHasBeenCancelled = true;
    }
    async setBody(body) {
        this.body = body;
        this.setState({ src: undefined });
        const value = this.context;
        const bearerToken = value.authorization.type === "bearer"
            ? value.authorization.accessToken
            : "";
        const blob = await loadBlob(body, this.props.url, bearerToken);
        if (this.fetchHasBeenCancelled) {
            return;
        }
        const src = window.URL.createObjectURL(blob);
        this.setState({ src });
    }
    render() {
        const src = this.state.src;
        return src ? React.createElement("img", { src: src }) : React.createElement(loader_1.Loader, null);
    }
}
exports.PsychrometricChart = PsychrometricChart;
async function loadBlob(body, url, accessToken) {
    if (url) {
        const response = await fetch(url, {
            method: "POST",
            headers: Object.assign({ "Content-Type": "application/json; charset=utf-8" }, (accessToken ? { Authorization: `Bearer ${accessToken}` } : {})),
            credentials: "include",
            body
        });
        return response.blob();
    }
    else {
        const response = await fetch("/internal/GetPsychrometricChartSvg", {
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            credentials: "include",
            body
        });
        return response.blob();
    }
}
function makeBody(props) {
    return JSON.stringify(props.source === "custom"
        ? {
            mollier: props.type === "mollier",
            si: props.si,
            points: props.points.map(amountObjectToPvsString),
            pressure: property_1.PropertyValue.toString(property_1.PropertyValue.fromAmount(props.pressure)),
            binCases: props.binCases.map(amountObjectToPvsString),
            binFields: props.binFields.map(amountObjectToPvsString),
            culture: "en-US"
        }
        : {
            mollier: props.type === "mollier",
            si: props.si,
            systemId: props.systemId,
            operatingCaseId: props.operatingCaseId,
            culture: "en-US"
        });
}
function amountObjectToPvsString(object) {
    return property_1.PropertyValueSet.toString(Object.keys(object).reduce((soFar, currentKey) => property_1.PropertyValueSet.setAmount(currentKey, object[currentKey], soFar), property_1.PropertyValueSet.Empty));
}
//# sourceMappingURL=component.js.map